import axios from "axios";
import {
  GET_BADGE_FIELDS_REQUEST,
  GET_BADGE_FIELDS_SUCCESS,
  GET_BADGE_FIELDS_FAIL,
  GET_BADGE_QUIZ_REQUEST,
  GET_BADGE_QUIZ_SUCCESS,
  GET_BADGE_QUIZ_FAIL,
  SUBMIT_BADGE_QUIZ_REQUEST,
  SUBMIT_BADGE_QUIZ_SUCCESS,
  SUBMIT_BADGE_QUIZ_FAIL,
  SELECTED_TECH_FIELD,
  GET_QUIZ_RESULT_BY_ID_REQUEST,
  GET_QUIZ_RESULT_BY_ID_SUCCESS,
  GET_QUIZ_RESULT_BY_ID_FAIL,
  GET_DASHBOARD_BADGE_QUIZ_REQUEST,
  GET_DASHBOARD_BADGE_QUIZ_SUCCESS,
  GET_DASHBOARD_BADGE_QUIZ_FAIL,
} from "../../constants/Badge/badgeConstants";
import { APIRequestURI } from "../../utils/api_request_uri";

// Action 1: Get Technology Fields
export const getBadgeFieldsAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_BADGE_FIELDS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const URI = new APIRequestURI().getBaseURI();
    const { data } = await axios.get(`${URI}/api/badges/fields`, config);

    dispatch({
      type: GET_BADGE_FIELDS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_BADGE_FIELDS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Action 2: Get Quiz Details for Selected Fields
export const getBadgeQuizAction = (fieldId, subfieldId) => async (dispatch) => {
  try {
    dispatch({
      type: GET_BADGE_QUIZ_REQUEST,
    });

    const config = {
      params: {
        technologyFieldId: fieldId,
        technologySubfieldId: subfieldId,
      },
    };

    const URI = new APIRequestURI().getBaseURI();
    const { data } = await axios.get(`${URI}/api/badges/quiz`, config);

    dispatch({
      type: GET_BADGE_QUIZ_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_BADGE_QUIZ_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Action 3: Submit Quiz Results
export const submitBadgeQuizAction =
  (quizId, answers) => async (dispatch, getState) => {
    try {
      dispatch({
        type: SUBMIT_BADGE_QUIZ_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };
      const bodyData = { quizId, answers };
      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.post(
        `${URI}/api/badges/quiz/submit`,
        bodyData,
        config,
      );

      dispatch({
        type: SUBMIT_BADGE_QUIZ_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SUBMIT_BADGE_QUIZ_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const restoreTechFieldAction = () => (dispatch) => {
  const storedData = sessionStorage.getItem("selectedTechField");
  if (storedData) {
    dispatch({ type: SELECTED_TECH_FIELD, payload: JSON.parse(storedData) });
    const data = JSON.parse(storedData);
    dispatch(getBadgeQuizAction(data?.fieldId, data?.subFieldId));
  }
};

export const selectTechFieldAction = (data) => (dispatch) => {
  const storedData = sessionStorage.getItem("selectedTechField");
  let finalData = data;

  if (storedData) {
    const parsedData = JSON.parse(storedData);

    // Compare old vs new
    if (
      parsedData.fieldId === data.fieldId &&
      parsedData.subFieldId === data.subFieldId
    ) {
      // Use existing session data if unchanged
      finalData = parsedData;
    } else {
      // Update session if user changed field or subfield
      sessionStorage.setItem("selectedTechField", JSON.stringify(data));
    }
  } else {
    // No previous session data
    sessionStorage.setItem("selectedTechField", JSON.stringify(data));
  }

  // Dispatch final data (either from session or updated)
  dispatch({ type: SELECTED_TECH_FIELD, payload: finalData });
};

export const getQuizResultByIdAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_QUIZ_RESULT_BY_ID_REQUEST });

    // Try reading from sessionStorage
    const cached = sessionStorage.getItem("quizResult");
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed.id === id) {
        dispatch({
          type: GET_QUIZ_RESULT_BY_ID_SUCCESS,
          payload: parsed.data,
        });
        return;
      }
    }

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const URI = new APIRequestURI().getBaseURI();
    const { data } = await axios.get(
      `${URI}/api/badges/quiz-result/${id}`,
      config,
    );

    // Save to session storage
    sessionStorage.setItem(
      "quizResult",
      JSON.stringify({
        id,
        data,
      }),
    );

    dispatch({
      type: GET_QUIZ_RESULT_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_QUIZ_RESULT_BY_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getCompletedBadgeQuizAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_DASHBOARD_BADGE_QUIZ_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const URI = new APIRequestURI().getBaseURI();
    const { data } = await axios.get(
      `${URI}/api/badges/dashboard/completed`,
      config,
    );

    dispatch({
      type: GET_DASHBOARD_BADGE_QUIZ_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_DASHBOARD_BADGE_QUIZ_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
